export default "__VITE_ASSET__rbTWfQv3__"